declare const GetParentResourceName: (() => string) | undefined

const resourceName = (): string =>
	typeof GetParentResourceName === 'function' ? GetParentResourceName() : 'nui'

const postToClient = <T = any>(eventName: string, data: any): Promise<T> =>
	fetch(`https://${resourceName()}/${eventName}`, {
		method: 'post',
		headers: { 'Content-Type': 'application/json; charset=UTF-8' },
		body: JSON.stringify(data ?? {}),
	}).then((response) => {
		return response.json()
	})

export class ClientApi {
	private static initialized = false

	private static events: {
		[eventName: string]: (data: any) => void
	} = {}

	static init() {
		if (ClientApi.initialized) return
		ClientApi.initialized = true
		window.addEventListener('message', ClientApi.handleMessage)
	}

	private static handleMessage = (event: MessageEvent) => {
		try {
			const data: Record<string, any> =
				typeof event.data === 'string' ? JSON.parse(event.data) : event.data

			if (!data.type) return

			const handler = ClientApi.events[data.type]
			if (handler) {
				const { type: _type, ...payload } = data
				handler(payload)
			}
		} catch { }
	}

	static request<T>(
		eventName: string,
		payload: any,
		timeout = 5000
	): Promise<T> {
		ClientApi.init()

		return new Promise<T>((resolve, reject) => {
			const timer = setTimeout(() => reject(new Error('Request timeout')), timeout)

			postToClient<T>(eventName, payload)
				.then((result) => {
					clearTimeout(timer)
					resolve(result)
				})
				.catch((error) => {
					clearTimeout(timer)
					reject(error)
				})
		})
	}

	static send = (eventName: string, data: any): void => {
		postToClient(eventName, data).catch(() => { })
	}

	static on = (eventName: string, callback: (data: any) => void) => {
		if (!ClientApi.initialized) ClientApi.init()
		ClientApi.events[eventName] = callback
		console.log('Event listener registered:', eventName)
	}

	static isWorking = (): boolean => {
		return typeof GetParentResourceName === 'function'
	}
}
